import { Schema } from "effect";
import { ShopperAiIntegrationId } from "../../../ids/definitions";

// Individual integration type literals derived from ShopperAiIntegrationType
export const GmailIntegrationType = Schema.Literal("gmail");
export const OutlookIntegrationType = Schema.Literal("outlook");
export const FacebookIntegrationType = Schema.Literal("facebook");
export const InstagramIntegrationType = Schema.Literal("instagram");
export const AttentiveIntegrationType = Schema.Literal("attentive");
export const PostscriptIntegrationType = Schema.Literal("postscript");
export const TelnyxSmsIntegrationType = Schema.Literal("telnyx_sms");
export const TiktokIntegrationType = Schema.Literal("tiktok");
export const RedoChatAiIntegrationType = Schema.Literal("redoChatAi");
export const RedoChatFlowIntegrationType = Schema.Literal("redoChatFlow");
export const RedoChatLiveIntegrationType = Schema.Literal("redoChatLive");
export const ContactFormIntegrationType = Schema.Literal("contactForm");

// Gmail channel data (excluding refreshToken)
export const GmailChannelData = Schema.Struct({
  email: Schema.String,
  emailSignature: Schema.NullOr(Schema.String),
  gmailAccountName: Schema.NullOr(Schema.String),
  gmailAccountImage: Schema.NullOr(Schema.String),
});
export type GmailChannelData = typeof GmailChannelData.Type;

// Outlook channel data (excluding refreshToken)
export const OutlookChannelData = Schema.Struct({
  email: Schema.String,
  emailSignature: Schema.NullOr(Schema.String),
  name: Schema.NullOr(Schema.String),
});
export type OutlookChannelData = typeof OutlookChannelData.Type;

// Facebook channel data (excluding accessToken, appScopedUserId)
export const FacebookChannelData = Schema.Struct({
  pageId: Schema.String,
  pageName: Schema.String,
  facebookProfilePicUrl: Schema.NullOr(Schema.String),
});
export type FacebookChannelData = typeof FacebookChannelData.Type;

// Instagram channel data (excluding accessToken, appScopedUserId)
export const InstagramChannelData = Schema.Struct({
  pageId: Schema.String,
  pageName: Schema.String,
  instagramBusinessAccountId: Schema.String,
  instagramProfilePicUrl: Schema.NullOr(Schema.String),
});
export type InstagramChannelData = typeof InstagramChannelData.Type;

// Attentive channel data (excluding accessToken, accessTokenExpireTime)
export const AttentiveChannelData = Schema.Struct({
  attentiveCompanyId: Schema.NullOr(Schema.String),
  attentiveCompanyName: Schema.NullOr(Schema.String),
});
export type AttentiveChannelData = typeof AttentiveChannelData.Type;

// Postscript channel data (excluding apiKey)
export const PostscriptChannelData = Schema.Struct({
  shopId: Schema.NullOr(Schema.String),
});
export type PostscriptChannelData = typeof PostscriptChannelData.Type;

// TikTok channel data (excluding accessToken, refreshToken, accessTokenExpireTime, refreshTokenExpireTime)
export const TiktokChannelData = Schema.Struct({
  shopId: Schema.String,
  sellerName: Schema.String,
  sellerRegion: Schema.String,
});
export type TiktokChannelData = typeof TiktokChannelData.Type;

// Redo Chat AI channel data (no specific data needed)
export const RedoChatAiChannelData = Schema.Struct({});
export type RedoChatAiChannelData = typeof RedoChatAiChannelData.Type;

// Redo Chat Flow channel data (no specific data needed)
export const RedoChatFlowChannelData = Schema.Struct({});
export type RedoChatFlowChannelData = typeof RedoChatFlowChannelData.Type;

// Redo Chat Live channel data (no specific data needed)
export const RedoChatLiveChannelData = Schema.Struct({});
export type RedoChatLiveChannelData = typeof RedoChatLiveChannelData.Type;

// Telnyx SMS channel data
export const TelnyxSmsChannelData = Schema.Struct({
  phoneNumber: Schema.String,
  telnyxPhoneNumberId: Schema.NullOr(Schema.String),
  messagingProfileId: Schema.NullOr(Schema.String),
});
export type TelnyxSmsChannelData = typeof TelnyxSmsChannelData.Type;

// Contact form channel data — tracks the default email and SMS integrations
// that merchants reply FROM when a contact form submission comes in.
export const ContactFormIntegrationChannelData = Schema.Struct({
  emailIntegrationId: Schema.NullOr(ShopperAiIntegrationId),
  smsIntegrationId: Schema.NullOr(ShopperAiIntegrationId),
});
export type ContactFormIntegrationChannelData =
  typeof ContactFormIntegrationChannelData.Type;
